import React from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import CardDataDetails, { CardDataDetailsProps } from "./CardDataDetails";

interface CardDataCarousalProps {
    cardDataCollection: CardDataDetailsProps[];
    title?: string;
    description?: string;
    isArabic?: boolean;
}

const CardDataCarousal: React.FC<CardDataCarousalProps> = (props) => {
    const { cardDataCollection, title, description, isArabic = false } = props;
    const animation = { duration: 30000, easing: (t: any) => t };
    const [sliderRef] = useKeenSlider({
        breakpoints: {
            "(max-width: 790px)": {
                slides: { perView: 4.5 },
            },
            "(max-width: 450px)": {
                slides: { perView: 1, origin: "center" },
                loop: true,
                drag: true,
            },
        },
        slides: { perView: 3 },
        loop: true,
        drag: true,
        created(s) {
            s.moveToIdx(5, true, animation);
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
    });

    return (
        <>
            <div className="header text-center lg:px-0 px-4 lg:pt-20 pt-24 mx-auto max-w-6xl">
                <h2 className="lg:text-4xl text-2xl text font-bold pb-4">{title}</h2>
                <div className="lg:text-lg text-base lg:px-32 px-0 ">{description}</div>
            </div>
            <section className="max-w-6xl flex space-x-5 mx-auto lg:py-14 py-10">
                <div className="w-full mx-auto parentdiv hidden md:flex flex-row justify-between">
                    {cardDataCollection.map((each, i) => (
                        <div key={`card_${i}`} className="mr-2">
                            <CardDataDetails {...each} isArabic={isArabic} />
                        </div>
                    ))}
                </div>
                <div className="w-full  mx-auto parentdiv block md:hidden">
                    <div ref={sliderRef} className="keen-slider sliderparent ">
                        {cardDataCollection.map((each, i) => (
                            <div className={`keen-slider__slide number-slide${i}`} key={i}>
                                <CardDataDetails {...each} isArabic={isArabic} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default CardDataCarousal;
